module.exports = __webpack_public_path__ + "img/banner-5.44d291fb.jpg";